module.exports = {
  VERWALTUNG: { api: 'VERWALTUNG', human: 'Verwaltung' },
  KUNDENKONTO: { api: 'KUNDENKONTO', human: 'Kundenkonto' }
}
